import styled from 'styled-components'
import EditorField from '../EditorField'

export const StyledEditorField = styled(EditorField)`
  position: relative;
`
